<div class="location-map-wrapper">
  <div #mapContainer class="location-map"></div>
  <p class="location-hint">
    <i class="fa-solid fa-circle-info"></i>
    {{ 'projects.location.hint' | translate }}
  </p>
</div>

@if (pendingCoordinates()) {
  <div class="location-coords">
    <span>
      <i class="fa-solid fa-location-dot"></i>
      {{ pendingCoordinates()![1] | number:'1.5-5' }}°,
      {{ pendingCoordinates()![0] | number:'1.5-5' }}°
    </span>
  </div>
}

<div class="location-actions">
  <p-button
    [label]="'button.save' | translate"
    icon="fa-solid fa-floppy-disk"
    [loading]="saving()"
    [disabled]="!pendingCoordinates() || saving()"
    (onClick)="save()"
  />
  @if (saved()) {
    <span class="location-saved">
      <i class="fa-solid fa-circle-check"></i>
      {{ 'projects.location.saved' | translate }}
    </span>
  }
</div>
